import { NOMINATIONS_TAB } from "@e50/components/E50Constants";
import { TabType } from "@hooks/useTabs";
import { cn } from "@util/helpers";

type NominationsTabMobileProps = {
  /** The function to change the tab state. */
  changeTab: (key: TabType) => void;
  /** The function to close the dropdown. */
  closeDropdown: () => void;
  /** The label string to get the active tab label. */
  activeLabel: string;
};

/**
 * Component to render E50 nominations tabs for mobile
 */
const NominationsTabMobile = ({
  changeTab,
  closeDropdown,
  activeLabel,
}: NominationsTabMobileProps): React.ReactElement => {
  return (
    <div
      className="absolute z-10 w-full bg-gray-150 py-3"
      data-testid="nominations-tab-mobile-component"
    >
      {NOMINATIONS_TAB.map(({ key, label }) => (
        <div
          key={key}
          onClick={() => {
            changeTab(key);
            closeDropdown();
          }}
          className={cn(
            "my-1 cursor-pointer px-4 py-2 text-black hover:bg-gray-100",
            { "bg-gray-650 text-white": activeLabel === label }
          )}
        >
          {label}
        </div>
      ))}
    </div>
  );
};

export default NominationsTabMobile;
